export default __webpack_public_path__ + "static/media/plus.a123a686.svg";